import type { ApiContextProps } from '../Contexts/ApiContext';
import type { IndexedDBContextProps } from '../Contexts/IndexedDBContext';
import type { LocalStorageContextProps } from '../Contexts/LocalStorageContext';
import type { ModeContextProps } from '../Contexts/ModeContext';
import type { SystemContextProps } from '../Contexts/SystemContext';
import type { TokenContextProps } from '../Contexts/TokenContext';
import type { UserContextProps } from '../Contexts/UserContext';
import Mode from '../Enums/Mode';
import TokenType from '../Enums/TokenType';
import { handleLogout } from './HandleLogout';

export async function handleDisconnect(apiContext: ApiContextProps, modeContext: ModeContextProps, localStorageContext: LocalStorageContextProps, indexedDBContext: IndexedDBContextProps, userContext: UserContextProps, tokenContext: TokenContextProps, systemContext: SystemContextProps): Promise<void> {

    handleLogout(modeContext, localStorageContext, false); //should also logout as it has not necessarily been done
    
    if (tokenContext.tokenType === TokenType.KFLEET) {
        void apiContext.api?.logout(tokenContext.token); //invalidates the refresh token, but no disaster if this is not done due to being offline
    }
    
    await indexedDBContext.indexedDBService.removeAllCommentItems();
    await indexedDBContext.indexedDBService.removeAllImageItems();
    await indexedDBContext.indexedDBService.removeAllCountries();
    await indexedDBContext.indexedDBService.removeAllUsers();
    await indexedDBContext.indexedDBService.removeAllChecklistModels();
    await indexedDBContext.indexedDBService.removeAllFilledChecklists();
    await indexedDBContext.indexedDBService.removeAllInspectors();
    await indexedDBContext.indexedDBService.removeAllInspectingCompanies();
    await indexedDBContext.indexedDBService.removeAllDepartments();
    await indexedDBContext.indexedDBService.removeAllUserDepartmentLinks();
    await indexedDBContext.indexedDBService.removeAllCategories();
    await indexedDBContext.indexedDBService.removeAllObservationModels();
    await indexedDBContext.indexedDBService.removeAllFilledObservations();
    await indexedDBContext.indexedDBService.removeAllObservationChapters();
    await indexedDBContext.indexedDBService.removeAllObservationSubChapters();
    await indexedDBContext.indexedDBService.removeAllObservationRuleSets();
    await indexedDBContext.indexedDBService.removeAllDocumentTreeNodes();
    await indexedDBContext.indexedDBService.removeAllDocumentNodes();
    await indexedDBContext.indexedDBService.removeAllDocuments();
    await indexedDBContext.indexedDBService.removeAllMemoTemplates();
    await indexedDBContext.indexedDBService.removeAllFolders();
    
    userContext.setCurrentUser(null);
    localStorageContext.localStorageService.clearCurrentUser();
    userContext.setLastActivity(null);
    localStorageContext.localStorageService.clearLastActivity();
    userContext.setHashedPin(null);
    localStorageContext.localStorageService.clearHashedPin();

    tokenContext.setToken(null);
    tokenContext.setRefreshToken(null);
    tokenContext.setExpiration(null);
    tokenContext.setTokenType(TokenType.TENANT);
    localStorageContext.localStorageService.clearToken();
    localStorageContext.localStorageService.clearRefreshToken();
    localStorageContext.localStorageService.clearExpiration();
    localStorageContext.localStorageService.clearTokenType();
    await indexedDBContext.indexedDBService.removeAllBugReports();

    apiContext.setApi(null);
    localStorageContext.localStorageService.clearApi();

    modeContext.setMode(Mode.CONNECT);
    localStorageContext.localStorageService.setMode(Mode.CONNECT);

    systemContext.setSystemName(null);
    systemContext.setApiVersion(null);
    systemContext.setIsOffice(false);
    systemContext.setMinAppVersion(null);
    systemContext.setAppEnabled(false);
    systemContext.setLogoUrl(null);
    systemContext.setServerTimezoneOffsetMinutes(null);
    systemContext.setTenantDisplayName(null);
    localStorageContext.localStorageService.clearSystemName();
    localStorageContext.localStorageService.clearApiVersion();
    localStorageContext.localStorageService.clearIsOffice();
    localStorageContext.localStorageService.clearMinAppVersion();
    localStorageContext.localStorageService.clearAppEnabled();
    await indexedDBContext.indexedDBService.clearLogoBlob();
    localStorageContext.localStorageService.clearServerTimezoneOffsetMinutes();
    localStorageContext.localStorageService.clearTenantDisplayName();
}